import React, { useContext } from "react";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { ThemeContext } from "./contexts/ThemeContext";
const themes = {
  red: {
    
    title: "#F20000",
    text: "#F20000",
  },
  yellow: {
    
    title: "#fccf14",
    text: "#fccf14",
  },
  green: {
    
    title: "#0cf702",
    text: "#0cf702",
  },
  blue: {
    
    title: "#00B8FF",
    text: "#00B8FF",
  },
  purple: {
    
    title: "#67009A",
    text: "#67009A",
  },
};

const GlobalStyle = createGlobalStyle`
   {
   
    font-family: 'Poppins', sans-serif
    
  }
`;

const Theme = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  return (
    <ThemeProvider theme={themes[theme]}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default Theme;